// extracted by mini-css-extract-plugin
export var backdropBlur = "_kj-0";
export var contentCard = "_kj-5";
export var frame = "_kj-2";
export var image = "_kj-4";
export var imagePane = "_kj-3";
export var modal = "_kj-1";